export default "/images/536941febedab93fd92c23349025e1f0.avif";